import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationThirdParty = createCrudVuexModule({
  namespaced: true,
  path: "/thirdparty",
  state: { isDownloading: false },
  getters: { isDownloading: (state) => state.isDownloading },
  mutations: { isDownloading: (state, value) => (state.isDownloading = value) },
  actions: {
    async download({ commit }) {
      commit("isDownloading", true);
      try {
        const response = await rest.post("/thirdparty/download");
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
  },
});
